"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTourName = exports.parsePhone = exports.updateErrorsObject = exports.getReqField = exports.formServerValidationMsg = exports.objInArrayFieldProps = exports.oneFieldObjInArrayFieldProps = exports.generateOverride = exports.generateValuePath = exports.initializeResourceValue = exports.generateInitialResourceValue = exports.getReadableErrorCode = exports.renderSegmentErrorMessages = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require("babel-runtime/helpers/extends");

var _extends5 = _interopRequireDefault(_extends4);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

exports.formSyncValidation = formSyncValidation;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _reactIntl = require("react-intl");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _utilityFunctions = require("utils/utilityFunctions");

var _components2 = require("components");

var _components3 = require("../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders validation error messages for a flight segment.
 *
 * Reads segment-level errors from the Redux response and renders each
 * as a <FormErrorMessage />. Error objects with a `code` are normalized
 * to renderable values to avoid old React crashes.
 *
 * Returns JSX or `false` when no errors are present.
 */
var renderSegmentErrorMessages = exports.renderSegmentErrorMessages = function renderSegmentErrorMessages(resourceDataCall, segment) {
    var hasResourceError = resourceDataCall && resourceDataCall.error;
    if (!hasResourceError) return false;

    // Get the form base path.
    // This is because the segment error messages are not setup to be shown directly on the fields.
    // Therefore, we only need to know which form it belongs to.
    var basePath = segment.split('].')[0] + "]";

    var fieldErrorObj = _lodash2.default.get(resourceDataCall.error, basePath);
    if (!fieldErrorObj) return false;

    return (0, _entries2.default)(fieldErrorObj).map(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        var message = error;
        if (error && (typeof error === "undefined" ? "undefined" : (0, _typeof3.default)(error)) === 'object') message = error.code || (0, _values2.default)(error)[0];

        if (typeof message !== "string") return false;

        return _react2.default.createElement(
            _components3.FormErrorMessage,
            { key: basePath + "-" + field },
            message
        );
    });
};

// Convert "ERROR_CODE_LIKE_THIS" into "Error code like this".
var getReadableErrorCode = exports.getReadableErrorCode = function getReadableErrorCode(code) {
    if (!code || typeof code !== "string") return "";
    return code.toLowerCase().split("_").join(" ")
    // Capitalize the first letter of the sentence
    .replace(/^\w/, function (c) {
        return c.toUpperCase();
    });
};

// Generates the initial resource value needed to initialize a resource to POST
var generateInitialResourceValue = exports.generateInitialResourceValue = function generateInitialResourceValue(_ref3) {
    var requirement = _ref3.requirement,
        resourceType = _ref3.resourceType,
        bookingId = _ref3.bookingId,
        departureServicesById = _ref3.departureServicesById;

    switch (resourceType) {
        case "completed_agreements":
            return {
                booking: { id: bookingId },
                requirement: { code: requirement.code },
                services: requirement.services.map(function (service) {
                    return {
                        id: service.id
                    };
                }),
                customer: { id: requirement.customer },
                agreements: []
            };
        case "flight_statuses":
            return {
                customers: [{ id: requirement.customer }],
                departure_service: { id: requirement.services[0].id },
                segments: [{}],
                departure_service_action: requirement.code === "ARRIVAL_FLIGHT_DETAILS" ? "ARRIVING" : "DEPARTING"
            };
        case "insurance_services":
            return {
                customers: [{ id: requirement.customer }],
                booking: { id: bookingId }
            };
        case "rooming_requests":
            if ((0, _keys2.default)(departureServicesById).length) {
                if ((0, _keys2.default)(requirement.toPostValuesByResourceType).length > 0) {
                    return {
                        departure: {
                            id: departureServicesById[requirement.services[0].id].product.id
                        },
                        room: { code: "STANDARD" },
                        bed_type: requirement.toPostValuesByResourceType.rooming_requests.bed_type ? requirement.toPostValuesByResourceType.rooming_requests.bed_type.value : '',
                        customers: requirement.toPostValuesByResourceType.rooming_requests.customers ? requirement.toPostValuesByResourceType.rooming_requests.customers.value : '',
                        approved_by: requirement.toPostValuesByResourceType.rooming_requests.approved_by ? requirement.toPostValuesByResourceType.rooming_requests.approved_by.value : ''
                    };
                } else {
                    return {
                        departure: {
                            id: departureServicesById[requirement.services[0].id].product.id
                        },
                        room: { code: "STANDARD" }
                    };
                }
            } else {
                return {};
            }
        case "overrides":
            return {
                customer: { id: requirement.customer },
                services: requirement.services.map(function (service) {
                    return {
                        id: service.id
                    };
                }),
                booking: { id: bookingId },
                reason: { code: "" },
                requirement: { code: requirement.code }
            };
        default:
            return {};
    }
};

var initializeResourceValue = exports.initializeResourceValue = function initializeResourceValue(props) {
    var requirement = props.requirement,
        resourceType = props.resourceType,
        initialValues = props.initialValues;

    // Initialize POST data for resource if it does not yet exist

    var postHref = requirement.toPostResourceHrefsByType[resourceType];
    var tempId = requirement.toPostTempIdsByResourceType[resourceType];
    if (postHref && tempId) {
        // Resource does not exist, initialize it
        // (user can't enter things like booking id, customer id, etc. in the form)
        initialValues.toPost = initialValues.toPost || {};
        initialValues.toPost[postHref] = initialValues.toPost[postHref] || {};
        initialValues.toPost[postHref][tempId] = generateInitialResourceValue(props);
    }
};

// Generates the value path used by redux-form to link the form's values to initialValues
var generateValuePath = exports.generateValuePath = function generateValuePath(_ref4) {
    var requirement = _ref4.requirement,
        resourceType = _ref4.resourceType;

    var postHref = requirement.toPostResourceHrefsByType[resourceType];
    var tempId = requirement.toPostTempIdsByResourceType[resourceType];
    var patchHref = requirement.fieldResourceHrefsByType[resourceType];
    if (postHref && tempId) {
        // Resource does not exist
        return "['toPost']['" + postHref + "']['" + tempId + "']";
    } else if (patchHref) {
        // Resource exists
        return "['" + patchHref + "']";
    } else {
        return null;
    }
};

var generateOverride = function generateOverride(_ref5) {
    var intl = _ref5.intl,
        id = _ref5.id,
        requirement = _ref5.requirement,
        overrideLabels = _ref5.overrideLabels,
        customOnChange = _ref5.customOnChange,
        props = (0, _objectWithoutProperties3.default)(_ref5, ["intl", "id", "requirement", "overrideLabels", "customOnChange"]);

    if (requirement) {
        var appliedOverride = requirement.applied_overrides[0];
        var overrides = appliedOverride ? _lodash2.default.uniqBy([].concat((0, _toConsumableArray3.default)(requirement.override_reasons), [appliedOverride.reason]), "id") : requirement.override_reasons;

        var getOverrideLabel = function getOverrideLabel(overrideCode) {
            var message = overrideLabels && overrideLabels[overrideCode];
            return message ? intl.formatMessage(message) : getReadableErrorCode(overrideCode);
        };

        if (overrides.length > 0) {
            return {
                id: id,
                label: overrides.length === 1 ? getOverrideLabel(overrides[0].code) : null,
                field: _react2.default.createElement(_reduxForm.Field, {
                    id: id,
                    name: generateValuePath({
                        requirement: requirement,
                        resourceType: "overrides"
                    }) + ".reason.code",
                    type: overrides.length === 1 ? "checkbox" : "select",
                    component: _components2.OverrideInput,
                    overrideLabels: overrideLabels,
                    requirement: requirement,
                    customOnChange: customOnChange,
                    initialValues: props.initialValues
                })
            };
        } else {
            return {
                hideField: true
            };
        }
    } else {
        return null;
    }
};

exports.generateOverride = generateOverride;
var oneFieldObjInArrayFieldProps = function oneFieldObjInArrayFieldProps(_ref6) {
    var findProp = _ref6.findProp,
        findValue = _ref6.findValue,
        WrappedComponent = _ref6.WrappedComponent;

    var oneFieldObjInArrayFieldComponent = function oneFieldObjInArrayFieldComponent(_ref7) {
        var input = _ref7.input,
            meta = _ref7.meta,
            type = _ref7.type,
            props = (0, _objectWithoutProperties3.default)(_ref7, ["input", "meta", "type"]);

        // If findProp with findValue found inside Field's value (array of 1field),
        // return an input component that is checked if findValue is found

        if (_lodash2.default.isArray(input.value)) {
            var arrIndex = input.value.findIndex(function (x) {
                return x[findProp] == findValue;
            });
            // soft equals in case num compared to string (ids, etc.)
            input.value = input.value && input.value[arrIndex] && input.value[arrIndex][findProp] || "";
            // we have to do both value and checked for checkbox to
            //  avoid dumb uncontrolled component error from react
            input.checked = input.value;
            if (meta.error && _lodash2.default.isArray(meta.error)) {
                meta.error = meta.error[arrIndex] || undefined;
            }
        }
        return _react2.default.createElement(WrappedComponent, (0, _extends5.default)({}, props, {
            meta: meta,
            input: input,
            type: type,
            customDisabled: props.customDisabled ? props.customDisabled : props.requirement && !props.requirement.editable
        }));
    };
    oneFieldObjInArrayFieldComponent.propTypes = {
        input: _propTypes2.default.object.isRequired,
        meta: _propTypes2.default.object.isRequired,
        type: _propTypes2.default.string
    };

    return {
        component: oneFieldObjInArrayFieldComponent,
        normalize: function normalize(value, prev) {
            // Return normalize function which will remove/include findValue
            //  if input is unchecked/checked respectively

            // TODO: make this work with new value_hidden thing
            var prevArr = _lodash2.default.isArray(prev) ? prev : [];

            var arrIndex = prevArr.findIndex(function (x) {
                return x[findProp] == findValue;
            });
            // soft equals in case num compared to string (ids, etc.)
            var inArray = arrIndex !== -1;

            if (value && !inArray) {
                return [].concat((0, _toConsumableArray3.default)(prevArr), [(0, _defineProperty3.default)({}, findProp, findValue)]);
            } else if (!value && inArray) {
                return prevArr.filter(function (x) {
                    return x[findProp] !== findValue;
                });
            } else {
                // !value && !inArray || value && inArray
                return prevArr;
            }
        }
    };
};

// The following props factory allows us to work with fields which need to map to a value
// inside an array, instead of a value which we can map 1-1 to with object properties
// Note: findProp is allowed to be a pathstring, at this time valueProp is not
exports.oneFieldObjInArrayFieldProps = oneFieldObjInArrayFieldProps;
var objInArrayFieldProps = function objInArrayFieldProps(_ref9) {
    var findValue = _ref9.findValue,
        findProp = _ref9.findProp,
        valueProp = _ref9.valueProp,
        _ref9$initialObj = _ref9.initialObj,
        initialObj = _ref9$initialObj === undefined ? {} : _ref9$initialObj,
        WrappedComponent = _ref9.WrappedComponent,
        _ref9$isCheckbox = _ref9.isCheckbox,
        isCheckbox = _ref9$isCheckbox === undefined ? false : _ref9$isCheckbox;

    var objInArrayFieldComponent = function objInArrayFieldComponent(_ref10) {
        var input = _ref10.input,
            meta = _ref10.meta,
            type = _ref10.type,
            props = (0, _objectWithoutProperties3.default)(_ref10, ["input", "meta", "type"]);

        // If object with property findProp === findValue found inside Field's value (array of objects),
        // return an input component with that object's valueProp value
        // (or if checkbox, will return checked if object is found)
        if (_lodash2.default.isArray(input.value)) {
            var arrIndex = input.value.findIndex(function (o) {
                return (0, _utilityFunctions.getResourceValue)(findProp, o) == findValue;
            });
            // soft equals in case num compared to string (ids, etc.)

            // Only perform this mutation when active
            // (to ensure it doesn't happen on form load which causes infinite loop)
            // TODO: DO NOT DO THIS. Calculate array index and intialize empty indices
            //  during value path creation instead and map accordingly
            if (arrIndex === -1 && meta.active) {
                // Initialize empty array object if not in the array
                var arrayVal = (0, _utilityFunctions.setResourceValue)(findProp, (0, _extends5.default)({}, initialObj, (0, _defineProperty3.default)({}, valueProp, isCheckbox ? false : "")), findValue);

                // Ensure we don't send requests for when a field gets touched then erased and we're left with it
                //  with a empty valueProp in the array
                // Mutate original array, don't register it as a change (initialValues change)
                input.value.push(arrayVal);
                arrIndex = input.value.length - 1;
            }

            var foundValue = input.value && input.value[arrIndex];

            input.value = foundValue && foundValue[valueProp] || "";
            if (isCheckbox) {
                // we have to do both value and checked for checkbox to
                //  avoid dumb uncontrolled component error from react
                input.checked = input.value;
            }
            if (meta.error && _lodash2.default.isArray(meta.error)) {
                meta.error = meta.error[arrIndex] ? meta.error[arrIndex][valueProp] : undefined;
            }
        }

        return _react2.default.createElement(WrappedComponent, (0, _extends5.default)({}, props, {
            meta: meta,
            input: input,
            type: type,
            customDisabled: props.customDisabled ? props.customDisabled : props.requirement && !props.requirement.editable
        }));
    };
    objInArrayFieldComponent.propTypes = {
        input: _propTypes2.default.object.isRequired,
        meta: _propTypes2.default.object.isRequired,
        type: _propTypes2.default.string
    };

    return {
        component: objInArrayFieldComponent,
        normalize: function normalize(value, prev) {
            // Return normalize function which will modify the field's array type value
            // depending on the value of the input (true if checkbox, string if text input, etc.)

            // TODO: make this work with new value_hidden thing
            var prevArr = _lodash2.default.isArray(prev) ? prev : [];

            var arrIndex = prevArr.findIndex(function (o) {
                return (0, _utilityFunctions.getResourceValue)(findProp, o) == findValue;
            });
            // soft equals in case num compared to string (ids, etc.)
            var inArray = arrIndex !== -1;

            if (inArray && value !== prevArr[arrIndex][valueProp]) {
                // Modify the object's valueProp (where object's findProp === findValue)
                var newArray = prevArr.map(function (obj) {
                    return (0, _extends5.default)({}, obj);
                });
                newArray[arrIndex][valueProp] = value;

                return newArray;
            } else if (value && !inArray) {
                // Insert initialObj and findProp/findValue into the field's array type value
                // (add in the valueProp + value if not type checkbox)
                var arrayVal = (0, _utilityFunctions.setResourceValue)(findProp, (0, _extends5.default)({}, initialObj, (0, _defineProperty3.default)({}, valueProp, value)), findValue);

                // return new array, registering it as a change in value
                return [].concat((0, _toConsumableArray3.default)(prevArr), [arrayVal]);

                // } else if (!value && inArray && !isCheckbox) {
                // TODO: remove from array instead of letting value just be '' when !isChecbox
                //       once API wants us to do that...
                // Remove object with findProp === findValue from field's array type value
                // return prevArr.filter(o => o[findProp] !== findValue)
                // }
            } else {
                return prevArr;
            }
        }
    };
};

// Returns errors object with errors for each required field whose value was not given
// (or empty object if no values in requiredValues were set and flag 'okIfNoneSet' is set)
exports.objInArrayFieldProps = objInArrayFieldProps;
var errorsIfRequired = function errorsIfRequired(_ref11) {
    var requiredValues = _ref11.requiredValues,
        values = _ref11.values,
        _ref11$okIfNoneSet = _ref11.okIfNoneSet,
        okIfNoneSet = _ref11$okIfNoneSet === undefined ? false : _ref11$okIfNoneSet;

    var errors = {};
    requiredValues.forEach(function (requiredValue) {
        if (!values[requiredValue]) {
            errors[requiredValue] = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.errors.fieldRequired",
                defaultMessage: "This field is required."
            });
        }
    });
    if (okIfNoneSet) {
        return (0, _keys2.default)(errors).length === requiredValues.length ? {} : errors;
    } else {
        return errors;
    }
};

var isValidETicketNumber = function isValidETicketNumber(eTicketNumber) {
    if (eTicketNumber && !eTicketNumber.includes("-") && eTicketNumber.length === 13) {
        return true;
    }
    return false;
};

var errorsIfNotValidETicketNumber = function errorsIfNotValidETicketNumber(_ref12) {
    var eTicketValues = _ref12.eTicketValues,
        values = _ref12.values;

    var errors = {};
    eTicketValues.forEach(function (eTicketValue) {
        if (!isValidETicketNumber(values[eTicketValue])) {
            errors[eTicketValue] = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.errors.fieldInvalidETicketNumber",
                defaultMessage: "Valid e-ticket numbers must not contain dashes and must be 13 digits long."
            });
        }
    });
    return errors;
};

var emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
var isValidEmail = function isValidEmail(email) {
    return emailRegEx.test("" + email);
};

// Returns errors object with errors for each email field whose value is not valid
var errorsIfNotEmail = function errorsIfNotEmail(_ref13) {
    var emailValues = _ref13.emailValues,
        values = _ref13.values;

    var errors = {};
    emailValues.forEach(function (emailValue) {
        if (!isValidEmail(values[emailValue])) {
            errors[emailValue] = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.errors.fieldInvalidEmail",
                defaultMessage: "This is not a valid email address."
            });
        }
    });
    return errors;
};

// Tests format (digits and separators) and valid months with days (doesn't calculate leap years)
var dateRegEx = /^\d{4}-(((0[1,3-9]|1[0-2])-(0[1-9]|[12][0-9]|30))|((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|(02-(0[1-9]|1[0-9]|2[0-9])))$/;
var isValidDate = function isValidDate(date) {
    return dateRegEx.test("" + date);
};

// Returns errors object with errors for each date field whose value is not valid
var errorsIfNotDate = function errorsIfNotDate(_ref14) {
    var dateValues = _ref14.dateValues,
        values = _ref14.values;

    var errors = {};
    dateValues.forEach(function (dateValue) {
        if (!isValidDate(values[dateValue])) {
            errors[dateValue] = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.errors.fieldInvalidDate",
                defaultMessage: "This is not a valid date."
            });
        }
    });
    return errors;
};

function formSyncValidation(_ref15) {
    var _ref15$requiredValues = _ref15.requiredValues,
        requiredValues = _ref15$requiredValues === undefined ? [] : _ref15$requiredValues,
        _ref15$requirements = _ref15.requirements,
        requirements = _ref15$requirements === undefined ? {} : _ref15$requirements,
        _ref15$dateValues = _ref15.dateValues,
        dateValues = _ref15$dateValues === undefined ? [] : _ref15$dateValues,
        _ref15$emailValues = _ref15.emailValues,
        emailValues = _ref15$emailValues === undefined ? [] : _ref15$emailValues,
        _ref15$eTicketValues = _ref15.eTicketValues,
        eTicketValues = _ref15$eTicketValues === undefined ? [] : _ref15$eTicketValues;

    return function (values) {
        var errors = {};

        // requirements
        // --
        // Array of fields in this object must either all be submitted or all be left empty
        // (also checks if override is set for that requirement)
        (0, _keys2.default)(requirements).forEach(function (reqCode) {
            var reqRequiredValues = requirements[reqCode].requiredValues;
            // if override, will all requirement's fields should be empty!
            errors = (0, _extends5.default)({}, errors, errorsIfRequired({
                requiredValues: reqRequiredValues,
                values: values,
                okIfNoneSet: true
            }));
        });

        // emailValues
        // --
        // All fields in this array must be valid email values
        errors = (0, _extends5.default)({}, errors, errorsIfNotEmail({
            emailValues: emailValues,
            values: values
        }));

        // dateValues
        // --
        // All fields in this array must follow our yyyy-mm-dd date format
        errors = (0, _extends5.default)({}, errors, errorsIfNotDate({
            dateValues: dateValues,
            values: values
        }));

        errors = (0, _extends5.default)({}, errors, errorsIfNotValidETicketNumber({
            eTicketValues: eTicketValues,
            values: values
        }));

        // requiredValues
        // --
        // All fields in this array must be submitted
        errors = (0, _extends5.default)({}, errors, errorsIfRequired({ requiredValues: requiredValues, values: values }));

        return errors;
    };
}

var formServerValidationMsg = exports.formServerValidationMsg = function formServerValidationMsg(field, errorCode) {
    switch (errorCode) {
        case "CUSTOMER_INVALID_PASSPORT_EXPIRY_DATE":
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.errors.invalidPassportExpiry",
                defaultMessage: "This passport is expired."
            });
        case "CUSTOMER_INVALID_PASSPORT_NUMBER":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidPassportNumber",
                    defaultMessage: "Invalid passport number."
                });
            }
        case "CUSTOMER_INVALID_STATE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidState",
                    defaultMessage: "Province does not exist in the country provided."
                });
            }
        case "CUSTOMER_UPDATE_INVALID_DATA":
        case "INVALID_DATA":
        case "VALUE_ERROR":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.customerInvalidData",
                    defaultMessage: "This is not a valid value."
                });
            }
        case "FLIGHT_STATUS_ARRIVING_NOT_APPLICABLE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.flightStatusArrivingNotApplicable",
                    defaultMessage: "Your flight arrives at least 21 days before the start of your tour. Select the appropriate checkbox above."
                });
            }
        case "ARRIVAL_AIRPORT_CODE_MATCHES_DEPARTURE_AIRPORT_CODE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.flightStatusArrivalMatchesDepartureAirport",
                    defaultMessage: "Arrival airport cannot match departure airport."
                });
            }
        case "ARRIVAL_DATETIME_LOCAL_REQUIRED_AFTER_DEPARTURE_DATETIME":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.flightStatusArrivalDatetime",
                    defaultMessage: "Arrival date is before the departure date."
                });
            }
        case "FLIGHT_STATUS_DEPARTING_NOT_APPLICABLE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.flightStatusDepartingNotApplicable",
                    defaultMessage: "Your flight departs at least 21 days after the end of your tour. Select the appropriate checkbox above."
                });
            }
        case "SEGMENT_DUPLICATE_DEPARTURE_AIRPORT_CODE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.segmentDuplicateDepartureAirportCode",
                    defaultMessage: "A segment in your flight has a duplicate departure airport code."
                });
            }
        case "SEGMENT_DEPARTURE_AFTER_ARRIVAL":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.segmentDepartureAfterArrival",
                    defaultMessage: "A segment in your flight has a departure time after the arrival time."
                });
            }
        case "SEGMENT_ARRIVAL_BEFORE_DEPARTURE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.segmentArrivalBeforeDeparture",
                    defaultMessage: "A segment in your flight has an arrival time before the departure time."
                });
            }
        case "INVALID_HEIGHT":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.insuranceInvalidHeight",
                    defaultMessage: "Traveller height must be between 140 and 215cm inclusive."
                });
            }
        case "INSURANCE_INVALID_COVERAGE_BEGIN":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.insuranceInvalidCoverageBegin",
                    defaultMessage: "Coverage period begins after start of adventure."
                });
            }
        case "INSURANCE_INVALID_COVERAGE_END":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.insuranceInvalidCoverageEnd",
                    defaultMessage: "Coverage period ends before end of adventure."
                });
            }
        case "INVALID_TICKET_NUMBER":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidTicketNumber",
                    defaultMessage: "Valid e-ticket numbers must not contain dashes and must be 13 digits long."
                });
            }
        case "VALIDATION_ERROR":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.validationError",
                    defaultMessage: "This field is invalid: {errorCode}",
                    values: { errorCode: getReadableErrorCode(field) }
                });
            }
        case "DEPARTURE_DATETIME_LOCAL_IN_PAST":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.localInPast",
                    defaultMessage: "Departure is in the past."
                });
            }
        case "DEPARTURE_DATETIME_LOCAL_BEYOND_ONE_YEAR":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.localBeyondOneYear",
                    defaultMessage: "Departure is too far into the future."
                });
            }
        case "REQUIREMENT_NOT_OVERRIDEABLE_FOR_SERVICE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.reqirementNotOverideable",
                    defaultMessage: "This override could not be applied for this service."
                });
            }
        case "CUSTOMER_NOT_IN_DEPARTURE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.customerNotInDeparture",
                    defaultMessage: "Customer is not booked in that departure."
                });
            }
        case "CUSTOMER_NOT_IN_REQUEST":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.customerNotInRequest",
                    defaultMessage: "Customer cannot approve the request as they aren't a part of it."
                });
            }
        case "ROOM_OVER_CAPACITY":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.roomOverCapacity",
                    defaultMessage: "Cannot fit all the customers in the given room."
                });
            }
        case "INVALID_BED_TYPE":
        case "INVALID_FLAG":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidBedType",
                    defaultMessage: "You cannot request this bed type for the roomate selected."
                });
            }
        case "INVALID_CUSTOMER_ID":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidCustomerId",
                    defaultMessage: "Cannot find customer by the given id."
                });
            }
        case "INVALID_DEPARTURE_ID":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidDepartureId",
                    defaultMessage: "Cannot find departure by the given id."
                });
            }
        case "INVALID_ROOM_CODE":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.invalidRoomCode",
                    defaultMessage: "Cannot find a room by the given code."
                });
            }
        case "CUSTOMER_HAS_MOR":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.customerHasMor",
                    defaultMessage: "You cannot request this bed type for the roomate selected."
                });
            }
        case "CUSTOMER_ROOMING_WITH_MINOR":
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.customerRoomingWithMinor",
                    defaultMessage: "Please note that we cannot room a minor in your group with another solo traveller on tour. Please make sure that a minor is roomed with their parent or guardian."
                });
            }
        default:
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMessages.errors.fieldSubmitFailed",
                    defaultMessage: "This field could not be saved with message: {errorCode}",
                    values: { errorCode: getReadableErrorCode(errorCode) }
                });
            }
    }
};

var getReqField = exports.getReqField = function getReqField(req, fieldName) {
    if (req.fieldValuesByResourceType.rooming_requests) {
        return req.fieldValuesByResourceType.rooming_requests[fieldName];
    } else if (req.toPostValuesByResourceType.rooming_requests) {
        return req.toPostValuesByResourceType.rooming_requests[fieldName];
    }
    return null;
};

var updateErrorsObject = exports.updateErrorsObject = function updateErrorsObject(_ref16) {
    var fieldPath = _ref16.fieldPath,
        error = _ref16.error,
        _ref16$errors = _ref16.errors,
        errors = _ref16$errors === undefined ? {} : _ref16$errors,
        _ref16$genErrorCode = _ref16.genErrorCode,
        genErrorCode = _ref16$genErrorCode === undefined ? "DEFAULT" : _ref16$genErrorCode;

    var newErrors = (0, _extends5.default)({}, errors);
    if (error._error) {
        newErrors._error = genErrorCode;
    } else if (error.errors) {
        error.errors.forEach(function (resourceErr) {
            if (resourceErr.field) {
                var rsrcFieldArray = resourceErr.field.split("/");
                if (rsrcFieldArray[rsrcFieldArray.length - 1] >= 0) {
                    // if field is an array index, move error up to top level
                    // (can't handle errors on an array index)
                    // TODO: COME UP WITH BETTER SOLUTION
                    newErrors._error = resourceErr.code;
                } else {
                    var fieldName = rsrcFieldArray[rsrcFieldArray.length - 1];
                    var rsrcFieldPath = rsrcFieldArray.reduce(function (pathStr, field) {
                        return pathStr + "['" + field + "']";
                    }, "");
                    if (rsrcFieldPath.includes("['bed_type']")) {
                        rsrcFieldPath = "['bed_type']";
                    }
                    if (rsrcFieldPath.includes("['customers']")) {
                        rsrcFieldPath = "['customers']";
                    }
                    if (rsrcFieldPath.includes("['flags']")) {
                        rsrcFieldPath = "['customers']";
                    }
                    newErrors = (0, _utilityFunctions.setResourceValue)(
                    // we use bracket notation so it works with arrays as well
                    fieldPath ? fieldPath + "." + rsrcFieldPath : rsrcFieldPath, newErrors, formServerValidationMsg(fieldName, resourceErr.code));
                }
            }
        });
    }
    return newErrors;
};

var parsePhone = exports.parsePhone = function parsePhone(value) {
    return value.replace(/[^\d-+\(\)\s]/g, "");
};

var getTourName = exports.getTourName = function getTourName(departureServicesById, requirement) {
    var serviceId = requirement.services[0] && requirement.services[0].id;
    var depService = serviceId ? departureServicesById[serviceId] : "";
    return depService ? depService.name : "";
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/forms.js
// module id = 23
// module chunks = 0